import { render, staticRenderFns } from "./SocialPostsList.vue?vue&type=template&id=7a8b7db2&"
import script from "./SocialPostsList.vue?vue&type=script&lang=js&"
export * from "./SocialPostsList.vue?vue&type=script&lang=js&"
import style0 from "./SocialPostsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports